import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { StaffAuthBrandPanel } from '@/components/layouts/components/StaffAuthBrandPanel';
import { ForgotPasswordSent } from '@/features/auth/components/ForgotPasswordSent';

export const Route = createFileRoute('/forgot-password/sent')({
  component: Page,
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === 'string' ? s.email : undefined,
  }),
});

function Page() {
  return (
    <AuthLayout brandPanel={<StaffAuthBrandPanel />} formSide="left">
      <ForgotPasswordSent variant="staff" />
    </AuthLayout>
  );
}
